import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiV2 from "api-v2";
import type { PanelDisclaimerSettings } from "newui/features/Rfx/Evaluation/types/panel.type";
import { DISCLAIMER_SETTINGS_KEY } from "./useDisclaimerSettings";

export interface SaveDisclaimerSettingsPayload {
	disclaimer_enabled: boolean;
	disclaimer_text?: string | null;
}

const saveDisclaimerSettings = async (
	payload: SaveDisclaimerSettingsPayload
): Promise<PanelDisclaimerSettings> => {
	const response = await apiV2.put("/company/panel-disclaimer-settings", payload);
	return (response.data as { data?: PanelDisclaimerSettings })?.data ?? response.data;
};

export const useSaveDisclaimerSettings = () => {
	const queryClient = useQueryClient();

	return useMutation<PanelDisclaimerSettings, Error, SaveDisclaimerSettingsPayload>({
		mutationFn: saveDisclaimerSettings,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [DISCLAIMER_SETTINGS_KEY] });
		},
	});
};
